import { StoreRecaptchaTokenProps } from './types'
import { useEffect } from 'react'

export const StoreRecaptchaToken = ({
  sitekey,
  action,
  verifyCallback,
  submitCount,
}: StoreRecaptchaTokenProps): null => {
  useEffect(() => {
    window.grecaptcha &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      window.grecaptcha.ready(() => {
        // this might be too early. We'd rather do it before form submission.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        window.grecaptcha.execute(sitekey, { action }).then(verifyCallback)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount])
  return null
}
